export const AUTH_TOKEN = 'auth_token'
export const imageUri = "https://konnocrm.s3.ca-central-1.amazonaws.com/"